import { useMemo } from 'react';
import type { components, paths } from '@lifeserver/models/cms';
import createFetchClient, { ClientOptions } from 'openapi-fetch';
import createClient from 'openapi-react-query';

export type CmsSchemas = components['schemas'];

/**
 * Typed client for the CMS server's own endpoints (anything defined in
 * `services/public/cms/server`, e.g. `/api/gift-jira/v1/…`, `/api/versions/v2/…`).
 *
 * NOTE: the CMS OpenAPI paths already include the `/api` prefix, so we pass
 * an empty `baseUrl` and let axios/fetch resolve them relative to the current
 * origin — unlike `useGiftApi` which prefixes `/api` because the private
 * gift service publishes paths without it.
 */
export const useCmsApi = (options: ClientOptions = { baseUrl: '' }) => {
    return useMemo(() => {
        const fetchClient = createFetchClient<paths>(options);
        return createClient(fetchClient);
    }, [options]);
};
